import LogRocket from 'logrocket';
import { filter, ignoreElements, map, tap } from 'rxjs/operators';

export default (action$) =>
  // On each action
  action$.pipe(
    // When the action is a rejected thunk
    filter(
      ({ error, type }) => error && error.name !== 'SilentThunkError' && !error.silent && type.endsWith('/rejected')
    ),
    // rehydrate the error object
    map(({ error, meta, type: actionType }) => {
      const e = Object.assign(new Error(), error);
      LogRocket.captureException(e, {
        tags: {
          source: 'thunkRejected',
          trigger: meta?.arg?.trigger,
          actionType,
        },
        extra: {
          requestId: meta?.requestId,
          actionType,
        },
      });
      return e;
    }),
    // log the error to the console
    // eslint-disable-next-line no-console
    tap(console.error),
    // do not dispatch any actions
    ignoreElements()
  );
